import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { AddWithdrawRequestApi } from '../../../../../api/request/wallet/withdraw.js';

const Crypto = ({ amount, resetAll, validateAmount }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            if (validateAmount) {
                toast.error(validateAmount);
                return;
            }
            if (!amount) {
                toast.error('Please enter withdrawal amount');
                return;
            }
            const params = {
                userId: userDetails?.id,
                amount: Number(amount),
                withdrawalMethod: 4,
                CryptoWalletAddress: values?.cryptoWalletAddress
            };

            const { data } = await AddWithdrawRequestApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form?.resetFields();
                resetAll();
            }
        } catch (error) {
            if (error?.response?.data?.message)
                toast.error(error?.response?.data?.message);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div>
            <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
                <div className="grid sm:grid-cols-2 gap-5">
                    <Form.Item
                        name='cryptoWalletAddress'
                        label={<span className="text-lg text-gray-500 font-medium">TRC20 Wallet Address</span>}
                        rules={[{ required: true, message: 'Please enter TRC20 Wallet Address.' }]}
                    >
                        <Input placeholder="TRC20 Wallet Address" size='large' />
                    </Form.Item>
                </div>

                <Form.Item
                    name='conditions'
                    valuePropName="checked"
                    rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                >
                    <Checkbox className='mt-4'>
                        Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                    </Checkbox>
                </Form.Item>

                <LoadableButton
                    className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                    type="submit"
                    lable='Submit'
                    isLoading={isLoading}
                    loadingLable='Adding request...'
                />
            </Form>
        </div>
    )
}

export default Crypto
